import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useModal } from 'components/shared/hooks';
import { Modal } from 'components/core/modal/constants';
import { FormattedMessage } from 'react-intl';
import { ButtonCondensed } from '@companycam/slab-web';

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: var(--cc_color_background_2);
  padding: var(--cc_size_spacing_s) var(--cc_size_spacing_m);
  border-radius: var(--cc_size_border_radius_m);
`;

const ProjectUsersSectionTitle = styled.span`
  color: var(--cc_color_utility_info);
  font-weight: 500;
  font-size: var(--cc_size_text_s);
`;

// #endregion

const GroupingHeader = (props) => {
  const onSubmit = props.onSubmit;
  const project = props.project;
  const { showModal } = useModal();

  return (
    <Header>
      <ProjectUsersSectionTitle>{props.title}</ProjectUsersSectionTitle>
      {props.assignUserButton ? (
        <ButtonCondensed
          color="primary"
          icon={{
            name: 'account-check',
            position: 'before',
          }}
          data-testid="project-users-modal__button-assign-users"
          onClick={() =>
            showModal(Modal.ADD_PROJECT_USERS, {
              project,
              onSubmit,
            })
          }
        >
          <FormattedMessage
            id="Projects.users.cta"
            defaultMessage="Assign Users"
            description="cta button in project users page"
          />
        </ButtonCondensed>
      ) : null}
    </Header>
  );
};

GroupingHeader.propTypes = {
  title: PropTypes.string,
  assignUserButton: PropTypes.bool,
  onSubmit: PropTypes.func,
  project: PropTypes.object,
};

export default GroupingHeader;
